import QueryString from 'qs';
import React, { useEffect, useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { authAxiosInstance } from '../../../utils/axiosConfig';
import { toast } from 'react-toastify';
import PageWithCard from '../../../components/infrastructure/PageWithCard';
import TableWithHeadingAndSearch from '../../../components/Table/TableWithHeadingAndSearch';

const QualityWiseInventory = () => {
    const { cuttingString } = useParams();
    const { qualityName, quality, location } = JSON.parse(atob(cuttingString));
    const [loading, setLoading] = useState(false);
    const [inventoryData, setInventoryData] = useState([]);

    useEffect(() => {
        const fetchInventory = async () => {
            try {
                setLoading(true);
                const string = QueryString.stringify({
                    quality,
                    location,
                });

                const resp = await authAxiosInstance.get(
                    `/inventory/cutting/byQuality?${string}`
                );
                setInventoryData(resp.data.data.docs);
            } catch (error) {
                console.log(error);
                toast.error('Failed to fetch data');
            } finally {
                setLoading(false);
            }
        };
        fetchInventory();
    }, [cuttingString]);

    const cols = useMemo(() => {
        return [
            {
                Header: 'Cutting Card#',
                accessor: 'cuttingCard.cuttingCardNumber',
                Cell: ({ row }) => {
                    const linkBinaryEncoded = btoa(
                        JSON.stringify({
                            location: location,
                            cuttingCardRef: row.original.cuttingCard._id,
                        })
                    );
                    return (
                        <Link
                            className="text-indigo-600 underline"
                            to={`/dashboard/cutting/card-inventory/${linkBinaryEncoded}`}
                        >
                            {row.original.cuttingCard.cuttingCardNumber}
                        </Link>
                    );
                },
            },
            {
                Header: 'location',
                accessor: 'location.name',
            },
            {
                Header: 'Fresh',
                Cell: ({ row }) => {
                    return <div>{row.original['stagesMap']['fresh']}</div>;
                },
            },

            {
                Header: 'Second',
                Cell: ({ row }) => {
                    return <div>{row.original['stagesMap']['second']}</div>;
                },
            },
        ];
    }, [cuttingString]);
    return (
        <PageWithCard heading={`${loading ? 'Loading...' : qualityName}`}>
            <TableWithHeadingAndSearch
                heading={'Inventory'}
                columns={cols}
                data={inventoryData}
            />
        </PageWithCard>
    );
};

export default QualityWiseInventory;
